import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import DesignationsEditTab from './Elements/DesignationsEditTab';
import DesignationRequisitionFormTab from './Elements/DesignationRequisitionFormTab';
import DesignationGroupTab from './Elements/DesignationGroupTab';
import DesignationCustomRequisitionTab from './Elements/DesignationCustomRequisitionTab';
import getLocale from '../../i18n/getLocale';

class DesignationsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      designation_data: {},
      aircraft_models_list: {},
      certifications_experience_list: {},
      designation_custom_requisitions: {},
      designation_requisitions: {},
      designation_experiences: {},
      designation_groups: {},
      certifications_list: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/designacao/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/designacoes');
        if (responseJson.status === 'success') {
          self.setState({designation_data: responseJson.data.designation_data});
          self.setState({designation_custom_requisitions: responseJson.data.designation_requisitions});
        }
      }).then(() => {
      var url = config.get('api') + '/designacao/requisicoes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({designation_requisitions: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/lista/modelos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/certificados/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({certifications_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/designacao/requisicao/grupo/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({designation_groups: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });  });  }); }); });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Designacoes.EditarDesignacao.titulo}</h3>
      <Link to="/designacoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.tituloTab}>
          <DesignationsEditTab handleAlert={this.handleAlert} designation_id={this.props.match.params.id} aircrafts_list={this.state.aircrafts_list} bases_list={this.state.bases_list} clients_list={this.state.clients_list} designation_data={this.state.designation_data} designation_backups={this.state.designation_backups} />
        </Tab>
        <Tab eventKey={2} title={this.locale.Designacoes.EditarDesignacao.tabRequisitosHorasDeVoo.tituloTab}>
          <DesignationRequisitionFormTab handleAlert={this.handleAlert} loadData={this.loadData} designation_id={this.props.match.params.id} aircraft_models_list={this.state.aircraft_models_list} designation_requisitions={this.state.designation_requisitions} certifications_list={this.state.certifications_list} />
        </Tab>
        <Tab eventKey={4} title={this.locale.Designacoes.EditarDesignacao.tabRequisitosPersonalizados.tituloTab}>
          <DesignationCustomRequisitionTab handleAlert={this.handleAlert} loadData={this.loadData} designation_id={this.props.match.params.id} designation_requisitions={this.state.designation_custom_requisitions} designation_groups={this.state.designation_groups} certifications_list={this.state.certifications_list} />
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default DesignationsEdit;



// WEBPACK FOOTER //
// ./src/Components/Designations/DesignationsEdit.js